import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ColumnLayoutViewModel from '@/ViewModels/Controls/ColumnLayoutViewModel';
import FlowLayoutItemViewModel from '@/ViewModels/Controls/FlowLayoutItemViewModel';

export default class FlowLayoutViewModel extends ControlViewModel {
    private ColumnLayoutViewModel = ComponentManager.getViewModel<typeof ColumnLayoutViewModel>('ColumnLayoutViewModel');
    private FlowLayoutItemViewModel = ComponentManager.getViewModel<typeof FlowLayoutItemViewModel>('FlowLayoutItemViewModel');

    /**
     * Die Factory-Tuples
     */
    public tuples: Array<any>;

    /**
     * Definiert den Modus, in dem das Layout gerendert wird
     */
    public mode: string;

    /**
     * Definiert die Orientierung des Layouts
     */
    public orientation: string;

    /**
     * Definiert die Ausrichtung des Layouts
     */
    public alignment: string;

    /**
     * Beinhaltet und verändert die Breite der LabelColumn
     */
    public labelColumnWidth: KnockoutObservable<number | string>;

    /**
     * Die FlowLayoutItems
     */
    public flowLayoutItems: KnockoutComputed<FlowLayoutItemViewModel[]>;

    /**
     * Das ColumnLayout
     */
    public columnLayout: ColumnLayoutViewModel;

    /**
     * Das ViewModel für die FlowLayout
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.tuples = this.paramOrDefault(params.tuples, []);
        this.mode = this.paramOrDefault(params.mode, 'Default');
        this.orientation = this.paramOrDefault(params.orientation, 'Horizontal');
        this.alignment = this.paramOrDefault(params.alignment, 'None');
        this.labelColumnWidth = this.observableOrDefault(params.labelColumnWidth, 200);

        this.flowLayoutItems = this.defineComputed(() => {
            let tuples = this.tuples;
            let result: FlowLayoutItemViewModel[] = [];

            if (this.mode === 'Default') {
                if (this.orientation === 'Horizontal') {
                    this.setNeighborMappingHorizontal(tuples, 0);
                }
            }

            for (let i = 0; i < tuples.length; i++) {
                if (tuples[i] != null) {
                    let item = new this.FlowLayoutItemViewModel({
                        tuple: tuples[i]
                    });

                    result.push(item);
                }
            }

            return result;
        });

        this.columnLayout = new this.ColumnLayoutViewModel({
            columnsPerRow: 2,
            labelColumnWidth: this.labelColumnWidth,
            tuples: (() => {
                let mode = this.mode;
                let orientation = this.orientation;
                let tuples = this.tuples;

                if (mode === 'ColumnBased') {
                    // Inhalte werden spaltenweise (und unter Vernachlässigung von colspans) eingefüllt.

                    // Anzahl der benötigten Zeilen, abhängig von der Anzahl der Tupel (N := tuples.length):
                    // - Falls N gerade  :   N   / 2
                    // - Falls N ungerade: (N+1) / 2
                    // Dies entspricht in beiden Fällen Math.ceil(N/2). 
                    var rows = Math.ceil(tuples.length / 2);

                    if (orientation === 'Horizontal') {
                        this.setNeighborMappingHorizontal(tuples, rows);
                    } else if (orientation === 'Vertical') {
                        this.setNeighborMappingVertical(tuples, rows);
                    }
                } else if (mode === 'Default') {
                    if (orientation === 'Vertical') {
                        this.setNeighborMappingVertical(tuples, 11);
                    }
                }

                return tuples;
            })()
        });
    }

    public setNeighborMappingHorizontal(tuples: Array<any>, rows: number) {
        for (let i = 0; i < tuples.length; i++) {
            if (i % rows !== 0 && i > 0) {
                tuples[i].factory.neighborOf = tuples[i - 1].factory.detailViewItem.name;
            }
        }
    }

    public setNeighborMappingVertical(tuples: Array<any>, rows: number) {
        for (let i = 0; i < tuples.length; i++) {
            if (i >= rows) {
                tuples[i].factory.neighborOf = tuples[i - rows].factory.detailViewItem.name;
            }
        }
    }
}

ComponentManager.setViewModel('FlowLayoutViewModel', FlowLayoutViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');